import { Pipe, PipeTransform } from '@angular/core';
import { KbAnalyseItemResponse, KbDiseaseItemResponse } from '@medindex-webapi';

@Pipe({
  name: 'analyseTypeCheck',
})
export class AnalyseTypeCheckPipe implements PipeTransform {
  transform(
    item: KbAnalyseItemResponse | KbDiseaseItemResponse | null
  ): KbAnalyseItemResponse | null {
    return (item as KbAnalyseItemResponse)?.hxid
      ? (item as KbAnalyseItemResponse)
      : null;
  }
}
